import React, { Component } from 'react';
import * as FontAwesome from 'react-icons/lib/fa';

export default class PeriodicalIteam extends Component {
  render() {
    const { id, name, enable, is_separately_charge, deleteClick, onpClick } = this.props;
    const initial = name ? name.charAt(0).toUpperCase() : '?';

    return (
      <div className="alloc-item-row">
        <span className="alloc-avatar">{initial}</span>
        <span className="alloc-item-row__name">{name}</span>
        {enable === 1 && (
          <span className="alloc-item-row__actions">
            {(is_separately_charge === true || is_separately_charge === 1) && (
              <span className="alloc-charge-badge">$</span>
            )}
            <span
              className="alloc-action-icon alloc-action-icon--delete"
              onClick={() => deleteClick(id)}
              title="Remove"
            >
              <FontAwesome.FaTrash />
            </span>
            <span
              className="alloc-action-icon alloc-action-icon--edit"
              onClick={() => onpClick(id)}
              title="Edit"
            >
              <FontAwesome.FaPencil />
            </span>
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/PeriodicalIteam/index.js